import React from "react";
import * as locales from "react-date-range/dist/locale";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { DateRange } from "react-date-range";
import { humanDateFormat } from "../../../config/constants";

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

const DateRangeComponent = ({ values, onChange, label, maxDate, minDate }) => {
  const me = {};

  const parseFilterDates = () => (values.startDate ? `${moment(values.startDate).format(humanDateFormat)} - ${moment(values.endDate).format(humanDateFormat)}` : "");

  const handleClearDates = () => {
    onChange({ rangeDates: { startDate: null, endDate: null } });
  };

  return (
    <OverlayTrigger
      trigger="click"
      key="top"
      placement="bottom"
      readOnly
      overlay={
        <Popover id="popover-basic">
          <Popover.Body onMouseLeave={() => me.filterDataRangeTrigger.click()}>
            <DateRange
              onChange={onChange}
              months={1}
              minDate={minDate || undefined}
              maxDate={maxDate || new Date()}
              direction="vertical"
              startDatePlaceholder="Desde"
              endDatePlaceholder="Hasta"
              scroll={{ enabled: true }}
              locale={locales.es}
              ranges={[{ ...values, key: "rangeDates", color: "var(--primary)" }]}
            />
          </Popover.Body>
        </Popover>
      }
    >
      <label htmlFor="filterDataRangeInput" className="col-form-label pt-0 w-100">
        {label}
        <div className="input-group w-100 ">
          <input
            ref={(input) => {
              me.filterDataRangeTrigger = input;
              return null;
            }}
            id="filterDataRangeInput"
            className={`form-control ${values.startDate ? "border-right-0" : ""}`}
            type="text"
            readOnly
            placeholder="Todo"
            value={parseFilterDates()}
            style={{
              backgroundColor: "white",
            }}
          />
          {values.startDate ? (
            <div className="input-group-append">
              <span className="input-group-text bg-white">
                <FontAwesomeIcon icon={faTimes} onClick={handleClearDates} />
              </span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </label>
    </OverlayTrigger>
  );
};

export default DateRangeComponent;
